import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';
import { DialogConfig, FormField } from '../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-section',
  standalone: false,
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss'
})
export class SectionComponent implements OnInit, OnDestroy {
  title = 'Section Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  systemForm: FormGroup;
  system: any[]=[]
  cols: any[] = [
    { field: 'name', header: 'Section Name', filterType: 'text', width: '200px' },
    // { field: 'section', header: 'Section', filterType: 'text', width: '300px' },
    { field: 'status', header: 'Status', filterType: 'text', width: '150px' },
  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false
  private subscriptions = new Subscription();

  // Reusable Dialog Configuration
  createDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;
  initialData: any = {};
  viewMode: boolean = false;

  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.systemForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
      status: [true],
    });

    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    // Create Dialog Configuration
    this.createDialogConfig = {
      title: 'Create Section',
      width: '80vw',
      formLayout: 'single-column',
      fields: [
        {
          key: 'name',
          label: 'Section Name',
          type: 'text',
          placeholder: 'Enter Section Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Section Code',
          type: 'text',
          placeholder: 'Enter Section Code',
          maxLength: 15,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true
          }
        }
      ],
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    };

    // Update Dialog Configuration
    this.updateDialogConfig = {
      title: 'Update Section',
      width: '80vw',
      formLayout: 'single-column',
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Section Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Code',
          type: 'text',
          placeholder: 'Enter Section Code',
          maxLength: 15,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true
          }
        },
        {
          key: 'status',
          label: 'Active',
          type: 'checkbox'
        }
      ],
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/section-master/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const sub = this.api.getAPI(url).subscribe((res: any) => {
      let resp = res.results
      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        status: item.status === 1 ? 'Active' : 'Inactive'
      }));

      this.totalRecords = res.count || 0
    });

    this.subscriptions.add(sub);
  }


  addSystem() {
    this.initialData = {
      name: '',
      code: '',
      description: '',
      status: true
    };
    this.viewMode = false;
    this.showDialog = true;
    this.getProposal();
  }
  // New event handlers for reusable dialog
  onCreateSubmit(formData: any): void {
    let payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      status: 1
    };
    
    const sub = this.api.postAPI('/master/section-master/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Section added successfully'
        });
        this.showDialog = false;
        this.getSystem();
      }
    });
    this.subscriptions.add(sub);
  }

  onUpdateSubmit(formData: any): void {
    let sectionId = this.selectedsystem.id;
    let payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      status: formData.status ? 1 : 2
    };
    
    const sub = this.api.putAPI(`/master/section-master/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Section updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      }
    });
    this.subscriptions.add(sub);
  }

  onDialogCancel(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
  }

  onDialogClose(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
  }
viewSystem(rowData: any) {
  this.viewMode = true;
  this.updateDialogConfig.title = 'View Section';
  this.updateDialogConfig.submitButtonText = 'Close';
  this.updateDialogConfig.showCancelButton = false;
  
  if (rowData && rowData.id) {
    this.selectedsystem = rowData;
    this.initialData = {
      name: rowData.name || '',
      code: rowData.code || '',
      description: rowData.description || '',
      status: rowData.status === 'Active' ? true : false
    };
    this.isUpdatedialog = true;
  }
}

updateSystem(equipment: any): void {
  this.viewMode = false;
  this.updateDialogConfig.title = 'Update Section';
  this.updateDialogConfig.submitButtonText = 'Submit';
  this.updateDialogConfig.showCancelButton = true;
  
  if (equipment && equipment.id) {
    this.selectedsystem = equipment;
    this.initialData = {
      name: equipment.name || '',
      code: equipment.code || '',
      description: equipment.description || '',
      status: equipment.status === 'Active' ? true : false
    };
    this.isUpdatedialog = true;
  }
}

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/section-master/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Section Deleted Successfully',
        });
        this.showDeleteDialog = false;
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }

  getProposal() {
    const sub = this.api.getAPI('/master/section-master/').subscribe((res: any) => {

      this.systemSection = res.map((section: any) => ({
        label: section.name,
        value: section.id
      }));

    });
    this.subscriptions.add(sub);
  }

  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/section', 'Edit') ||
      this.permissionService.hasPrivilege('/master/section', 'Delete')||
      this.permissionService.hasPrivilege('/master/section', 'View');
  }
}
